import { UpdateUserCarouselsArguments } from 'api/userCarousels/types'
import { createSuffix } from 'utils/createSuffix'

import type { FetchFaqItemParameters } from 'api/admin/faqItems/types'
import type { FetchUsersParameters } from 'api/admin/users/types'
import type { FetchConversationsArguments } from 'api/conversations/types'

export const routes = {
  admin: {
    faqGroupsPath: (faqGroupId?: number) => `/api/admin/faq_groups/${faqGroupId || ''}`,
    faqItemsPath: ({ faqGroupId, faqItemId }: FetchFaqItemParameters) => `/api/admin/faq_groups/${faqGroupId}/faq_items/${faqItemId || ''}`,
    serviceMessagesPath: (serviceMessageId = '') => `/api/admin/service_messages/${serviceMessageId}`,
    userPath: (uuid: string) => `/api/admin/users/${uuid}`,
    usersPath: ({ query, page, perPage }: FetchUsersParameters) => `/api/admin/users${createSuffix({ page, per_page: perPage, q: query })}`,
  },
  attachmentsPath: (id?: number) => id ? `/api/attachments/${id}` : '/api/attachments',
  conversationMessagesPath: (id: string) => `/api/conversations/${id}/messages`,
  conversationTitlesPath: () => '/api/conversation_titles',
  // NOTE: WHhn we create a conversation we sent a string, when we fetch/update/delete it's a number.
  conversationPath: (id = '') => `/api/conversations/${id}`,
  conversationsListPath: ({ page, limit }: FetchConversationsArguments = { limit: 1 }) => `/api/conversations/${createSuffix({ limit, page })}`,
  pendingConversationsListPath: () => '/api/pending_conversations',
  conversationsSearchPath: ({ page, limit }: FetchConversationsArguments = { limit: 1 }) => `/api/conversation_search/${createSuffix({ limit, page })}`,
  conversationErrorPath: () => `/api/conversation_errors`,
  createTokenPath: () => '/api/tokens/create',
  eventsPath: () => 'api/events',
  faqGroupsPath: () => `/api/faq_groups`,
  messagesCancelStreamingPath: (id: string) => `/api/messages/${id}/cancel`,
  messagesFeedbacksPath: (id: string) => `/api/messages/${id}/feedbacks`,
  messagesPath: (id: string) => `/api/messages/${id}`,
  messagesStatusPath: (id: string) => `/api/messages/${id}/status`,
  messagesStreamPath: (id: string) => `/api/messages/${id}/stream`,
  messagesResponsesPath: (id: string) => `/api/messages/${id}/responses`,
  onboardingTipsPath: () => '/api/onboarding_tips',
  onboardingTipsDestroyAllPath: () => '/api/onboarding_tips/destroy_all',
  refreshTokenPath: (refreshToken: string) =>
    `/api/tokens/refresh${createSuffix({ refreshToken })}`,
  promptTemplatesPath: (id = '') => `/api/prompt_templates/${id}`,
  promptTemplateSearchPath: () => '/api/prompt_template_search',
  serviceMessagesPath: () => 'api/service_messages',
  suggestionsPath: (agentMode: string, q: string) =>
    `/api/suggestions${createSuffix({ agent_mode: agentMode, q })}`,
  userCarouselsPath: (args?: UpdateUserCarouselsArguments) => {
    const { slug, dismissed } = args || {}
    if (slug) {
      return `api/user_carousels/${slug}${createSuffix({ user_carousel: { dismissed: dismissed ? 'true' : 'false' } })}`
    }
    return 'api/user_carousels'
  },
  userPath: () => '/api/user',
}
